// import hero slider images
import HeroSlideImage1 from "./assets/img/dogs/cat-slide-1.png";
import HeroSlideImage2 from "./assets/img/dogs/dog-slide-1.png";
import HeroSlideImage3 from "./assets/img/dogs/dog-slide-3.png";
import HeroSlideImage4 from "./assets/img/about/about-img-2.png";
import HeroSlideImage5 from "./assets/img/about/about-img-1.png";
import HeroSlideImage6 from "./assets/img/about/about-img-3.png";
// import dog category images
import DogCateg1 from "./assets/img/dogs/dog-categ-1.png";
import DogCateg2 from "./assets/img/dogs/dog-categ-2.png";
import DogCateg3 from "./assets/img/dogs/dog-categ-3.png";
import DogCateg4 from "./assets/img/dogs/dog-categ-4.png";

// import aboutImage1 from "./assets/img/about/about-img-1.jpg";
// import aboutImage2 from "./assets/img/about/about-img-2.jpg";
// import aboutImage3 from "./assets/img/about/about-img-3.jpg";

// import social icons
import { AiFillYoutube, AiFillInstagram, AiFillGithub } from "react-icons/ai";

export const navigation = [
  {
    name: "Início",
    href: "/",
  },
  // {
  //   name: "Sobre nós",
  //   href: "#",
  // },
  {
    name: "Nosso App",
    href: "#app",
  },
];

export const heroSlider = [
  {
    id: 1,
    title: "Conheça o Inclusive Pet.",
    image: <HeroSlideImage1 />,
    subtitle:
      "Conheça o Inclusive Pet, plataforma voltada para os pets e seus donos que procura levar conforto e melhores opções para os amantes de bichinhos.",
    buttonText: "Saber Mais",
  },
  {
    id: 2,
    title: "O que é?",
    image: <HeroSlideImage2 />,
    subtitle:
      "O Inclusive Pet é um aplicativo que leva até você amantes de pets conforto e praticidade no dia a dia, te mostrando os melhores lugares para levar seu pet, te conecta a outras pessoas com a mesma paixão e uma outra infinidade de coisas.",
    buttonText: "Saber Mais",
  },
  {
    id: 3,
    title: "Onde atuamos?",
    image: <HeroSlideImage3 />,
    subtitle:
      "O Inclusive Pet por enquanto atua apenas na cidade de Garanhuns no estado de Pernamnbuco. Tentamos levar a melhor experiência possível para a população de Garanhuns e em breve pretendemos expandir para outras cidades.",
    buttonText: "Saber Mais",
  },
];

export const about = [
  {
    id: 1,
    title: "Animais para adoção.",
    image: <HeroSlideImage4 />,
    subtitle:
      "No nosso app você fica por dentro dos animais que estão disponíveis para adoção, podendo entrar em contato com o respectivo dono ou ONG responsável pelo animal.",
  },
  {
    id: 2,
    title: "ONGs de resgate a animais.",
    image: <HeroSlideImage5 />,
    subtitle:
      "ONGs de proteção e resgate de animais podem se cadastrar em nosso app, pensamos nisso como uma forma de facilitar os protetores de animais e aqueles que procuram ajudar uma respectiva ONG ou animal que deseje adotar.",
  },
  {
    id: 3,
    title: "O melhor para o seu pet.",
    image: <HeroSlideImage6 />,
    subtitle:
      "Com uma longa pesquisa, disponibilizamos para nossos usuários uma lista com os melhores lugares da cidade de Garanhuns para cuidados com pets, desde petshops até as melhores casas de ração.",
  },
];

export const bundleData = [
  {
    id: 1,
    image: <DogCateg1 />,
    name: "small",
    dogCategory: "1 - 9 kg",
    services: [
      {
        name: "smart",
        price: 20,
        list: ["wash", "ears cleaning", "nail cut", "perfumed"],
      },
      {
        name: "premium",
        price: 40,
        list: [
          "all smart services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
        ],
      },
      {
        name: "royal",
        price: 60,
        list: [
          "all premium services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
          "service 5",
          "service 6",
        ],
      },
    ],
  },
  {
    id: 2,
    name: "medium",
    image: <DogCateg2 />,
    dogCategory: "10 - 19 kg",
    services: [
      {
        name: "smart",
        price: 80,
        list: ["wash", "ears cleaning", "nail cut", "perfumed"],
      },
      {
        name: "premium",
        price: 100,
        list: [
          "all smart services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
        ],
      },
      {
        name: "royal",
        price: 120,
        list: [
          "all premium services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
          "service 5",
          "service 6",
        ],
      },
    ],
  },
  {
    id: 3,
    name: "big",
    image: <DogCateg3 />,
    dogCategory: "20 - 29 kg",
    services: [
      {
        name: "smart",
        price: 140,
        list: ["wash", "ears cleaning", "nail cut", "perfumed"],
      },
      {
        name: "premium",
        price: 160,
        list: [
          "all smart services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
        ],
      },
      {
        name: "royal",
        price: 180,
        list: [
          "all premium services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
          "service 5",
          "service 6",
        ],
      },
    ],
  },
  {
    id: 4,
    name: "super",
    image: <DogCateg4 />,
    dogCategory: "30 - 39 kg",
    services: [
      {
        name: "smart",
        price: 200,
        list: ["wash", "ears cleaning", "nail cut", "perfumed"],
      },
      {
        name: "premium",
        price: 210,
        list: [
          "all smart services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
        ],
      },
      {
        name: "royal",
        price: 220,
        list: [
          "all premium services",
          "service 1",
          "service 2",
          "service 3",
          "service 4",
          "service 5",
          "service 6",
        ],
      },
    ],
  },
];

export const social = [
  {
    icon: <AiFillYoutube />,
    href: "#",
  },
  {
    icon: <AiFillInstagram />,
    href: "#",
  },
  {
    icon: <AiFillGithub />,
    href: "#",
  },
];
